import React from 'react'
import propTypes from 'prop-types'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import {ThemeContext} from './ThemeProvider'
import {createMuiTheme} from './index'

/**
 * DynamicMuiThemeProvider
 *
 * Wrapper around Material-UI's MuiThemeProvider that dynamically generates
 * the theme based on the current theme context (light/dark).
 *
 * When the user toggles between light and dark mode, this component
 * regenerates the Material-UI theme with appropriate colors.
 *
 * IMPORTANT: We use a key to force Material-UI v0.20.2 to re-mount when
 * the theme changes, as it doesn't properly update when muiTheme prop changes.
 */
class DynamicMuiThemeProvider extends React.Component {
  static contextType = ThemeContext

  render() {
    const {children} = this.props
    const {theme} = this.context || {}
    const themeMode = theme || 'light'

    // Generate the Material-UI theme based on current mode
    const muiTheme = createMuiTheme(themeMode)

    return (
      <MuiThemeProvider key={themeMode} muiTheme={muiTheme}>
        {children}
      </MuiThemeProvider>
    )
  }
}

DynamicMuiThemeProvider.propTypes = {
  children: propTypes.node,
}

export default DynamicMuiThemeProvider
